import * as types from './types';

export const createSprintPurchase = (subId, sku, planType) => ({
  type: types.CREATE_SPRINT_PURCHASE,
  payload: { subId, sku, planType }
});

export const createBypassedPurchase = (subId, sku, planType, deviceId) => ({
  type: types.CREATE_BYPASSED_PURCHASE,
  payload: { subId, sku, planType, deviceId }
});

export const createQuickPurchase = (subId, sku, planType, deviceId) => ({
  type: types.CREATE_QUICK_PURCHASE,
  payload: { subId, sku, planType, deviceId }
});
